/**
 * Created by Allan on 2025/03/09.
 * Contact 84880528@qq.com.
 * 金额转换为万元单位
 */
export default function(value){
	if(!value) return '';
	if(value==='-') return 0
	return (Number(value)/10000).toFixed(2)
}



// WEBPACK FOOTER //
// ./src/filter/moneyFilter.js